'use client'

import { useGuardedRouter } from '@/useGuardedRouter'
import { useSearchRecommendations } from '@/useSearchRecommendations'

interface SearchRecommendationsProps {
  onSelect: (term: string) => void
}

export const SearchRecommendations = ({
  onSelect,
}: SearchRecommendationsProps) => {
  const router = useGuardedRouter()
  const { getRecommendations } = useSearchRecommendations()
  const recommendations = getRecommendations()

  const handleClick = (term: string) => {
    onSelect(term)
    router.push(`/search?query=${encodeURIComponent(term)}`)
  }

  if (recommendations.length === 0) {
    return null
  }

  return (
    <div className="px-3 lg:px-2 py-4">
      <p className="text-xs font-semibold text-gray-500 uppercase mb-3">
        Popular Searches
      </p>
      <div className="flex flex-wrap gap-2">
        {recommendations.map((rec, index) => (
          <button
            key={`${rec.term}-${index}`}
            onClick={() => handleClick(rec.term)}
            className="px-3 py-1.5 text-sm text-gray-700 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-150 border border-gray-200 hover:border-gray-300"
          >
            {rec.term}
          </button>
        ))}
      </div>
    </div>
  )
}
